import { BaseStore } from "stores/base_store"
import { runInAction, makeAutoObservable } from "mobx"
import { api_get } from "api/utils"
import { api_post } from "api/utils"

export type CalendarListItemType = {
    name: string;
    description: string;
    summary: string;
    summaryOverride?: string;
    id: string;
    timeZone: string;
    color: string;
    backgroundColor: string;
    foregroundColor: string;
    primary?: boolean;
    access_role?: string;
};


export type CalendarAuthType = {
    key: string;
    uuid: string;
    identity: string;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: CalendarAuthType) => void;
};

// Domain object CalendarAuth
export class CalendarAuth implements CalendarAuthType {
    key = "";
    uuid = "";
    identity = "";

    date_created = "";
    date_updated = "";

    constructor(attributes: CalendarAuthType) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: CalendarAuthType) {
        runInAction(() => {
            Object.assign(this, attributes);
        });
    }
}


export class CalendarAuthStore extends BaseStore<CalendarAuthType, CalendarAuth> {


    async fetchAuthUrl(identity: string): Promise<string | null> {
        const response = await api_get(`/calendar-auth/get-auth-url?identity=${identity}`);
        if(response.ok) {
            const data = await response.json();
            return data.authorization_url;
        }
        return null;
    }

    async fetchAvailableCalendars(identity: string): Promise<CalendarListItemType[]> {
        const response = await api_get(`/calendar-auth/google-available-calendars?identity=${identity}`);
        if(response.ok) {
            const data = await response.json();
            console.log("returning data: %o", data.calendars);
            return data.calendars;
        }
        return [] as CalendarListItemType[];
    };



    async addToSyncedCalendar(identity: string, calendar_id: string): Promise<boolean> {
        const data = { identity, calendar_id };
        const response = await api_post('/calendar-auth/google-add-synced-calendar', data);
        if(response.ok) {
            await response.json();
            return true;
        }
        return false;
    };

    async removeFromSyncedCalendars(identity: string, calendar_id: string): Promise<boolean> {
        const data = { identity, calendar_id };
        const response = await api_post('/calendar-auth/google-remove-synced-calendar', data);
        if(response.ok) {
            await response.json();
            return true;
        }
        return false;
    };

    async setCalendarPreferences(soi: string, preferences: string): Promise<string> {
        const data = { identity: soi, preferences };
        const response = await api_post('/calendar-auth/set-calendar-preferences', data);
        if(response.ok) {
            const data = await response.json();
            return data.preferences;
        }
        return ''
    };


    async fetchCalendarPreferences(soi: string): Promise<string> {
        const params = { identity: soi };
        const response = await api_get('/calendar-auth/get-calendar-preferences', params);
        if(response.ok) {
            const data = await response.json();
            return data.preferences;
        }
        return ''
    };

    modelConstructor() {
        return CalendarAuth;
    }

}
